<template>
  <div ref="ueditorWrap">
    <vue-ueditor-wrap
      class="vue-ueditor-wrap"
      :destroy="true"
      @ready="ready"
      id="myeditor"
      mode="listener"
      v-model="msg.innerHTML"
      :config="editorConfig"
    ></vue-ueditor-wrap>
  </div>
</template>

<script>
const TAG_NAME_TABLE = "TABLE";
const MARGIN_BOTTOM = 10;
import VueUeditorWrap from "vue-ueditor-wrap";
import { UEDITOR_CONFIG, UEDITOR_CONFIG_BLANK,UEDITOR_CONFIG_BLANK_SCORE,TAG_P_HEIGHT, PADDING_TOP,KONGGE_ELEMENT,KONGGE_ELEMENT_UNDERLINE, WHITE_SPACE_NBSP, WHITE_SPACE_NONBSP } from "@/subjects/constant";
import { PADDING_SIDES } from "@/utils/html2pdf/html2canvas";
import MyDragImage from "../../../assets/js/utils/base/MyDragImage";
import MyDragImageLimit from "../../../assets/js/utils/base/MyDragImageLimit";
export default {
  props: ["msg"],
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      myVal: "<span>哈哈哈</span>",
      toolbarClicked: false,
      imageClicked: false,
      editorClicked: false,
      editorInstance: undefined,
      mouseLeaveSignal: false,
      focusSignal: true,
      realHeightAfterEdit: 0,
      cacheContent: "",
      // 编辑器点击（获取焦点）时的html内容
      editorHtmlBeforeClicked: "",
      editorTagType: ["p", "table", "image"],
    };
  },
  computed: {
    editorConfig() {
      const CONFIG = this.msg.type ==  1? (this.msg.eachBlankScore ? UEDITOR_CONFIG_BLANK_SCORE: UEDITOR_CONFIG_BLANK) : UEDITOR_CONFIG;
      return this.$store.state.answerPanel.answerSheet.acCardHideScore
        ? {
            ...CONFIG,
            initialStyle: `p{line-height:${TAG_P_HEIGHT}px;} .row span.score {display: none;}`,
          }
        : CONFIG;
    },
  },
  // watch: {
  //   "$store.state.answerPanel.answerSheet.acCardHideScore": () => {
  //     if (this.editorInstance) {
  //       debugger;
  //       thi s.editorInstance.undoManager.update();
  //     }
  //   },
  // },
  methods: {
    showToolbarWhenFocus(editorInstance,toolbar) {
     editorInstance.addListener("focus", (editor) => {
        toolbar && (toolbar.style.display = "block");
      });
    },
    handlerToolbarMouseEnter(toolbar) {
      toolbar.onmouseenter = () => {
        this.toolbarClicked = true;
        this.$emit("onMouseEnter");
      };
      toolbar.onmouseleave = () => {
        this.toolbarClicked = false;
      };
    },
    handlerEditorMouseDown(editorInstance) {
      editorInstance.addListener("mousedown", (editor, evt) => {
        if (evt.target.tagName == "IMG") {
          this.imageClicked = true;
          evt.preventDefault();
          // const dragImage = new MyDragImage(evt);
          const dragImageLimit = new MyDragImageLimit(evt);
          dragImageLimit.setMaxHeight(this.msg.initDragHeight);
          if(this.$store.state.answerPanel.answerSheet.acCardPanes == 3) {
            dragImageLimit.setMaxWidth(505);
          } else {
            dragImageLimit.setMaxWidth(706);
          }
          // 和下面的mouseup触发失焦 操作一样 后期代码可以优化下
          this.$refs.ueditorWrap.onmouseleave = (e) => {
            if( this.imageClicked ) {
              console.log("离开图片",this.msg);
              let mycontent = editorInstance.getContent() ;
              // let mycontent = this.contrastDifferentEditorContent(editorInstance.getContent(), evt);
              if(mycontent.split(KONGGE_ELEMENT).length > 1) mycontent = this.appendKONGGEToSPAN((mycontent&& mycontent.split(KONGGE_ELEMENT)),KONGGE_ELEMENT);
              mycontent &&
              this.$emit("onBlur", {
              editorHeight: this.msg.initDragHeight,
              content: mycontent,
              isEnterKeyUp: this.isEnterKeyUp,
              overstepDistance: 0,
              });
              this.toolbarClicked = false;
              this.$refs.ueditorWrap.onmouseleave = null;
            } 
          };
          // this.$refs.ueditorWrap.addListener("mouseleave", (e) => {

          // });
        }
      });
    },
    handlerEditorMouseUp(editorInstance) {
      editorInstance.addListener("mouseup", (editor, evt) => {
      if (evt.target.tagName == "IMG") {
          let mycontent = editorInstance.getContent() ;
       if(mycontent.split(KONGGE_ELEMENT).length > 1) mycontent = this.appendKONGGEToSPAN((mycontent&& mycontent.split(KONGGE_ELEMENT)),KONGGE_ELEMENT);
          mycontent &&
            this.$emit("onBlur", {
              editorHeight: this.msg.initDragHeight,
              content: mycontent,
              isEnterKeyUp: this.isEnterKeyUp,
              overstepDistance: 0,
            });
          this.toolbarClicked = false;
        } else {
          // this.toolbarClicked = true;
        }
        document.onmousemove = null;
        this.$emit("onMouseDown");
        // const timer = setTimeout(() => {
        //   this.focusSignal && editorInstance.focus(true); // 光标强制到末尾
        //   this.focusSignal = false;
        //   clearTimeout(timer);
        // }, 80);
      });
    },
    /**
     *  对比编辑器失焦前后的content内容（对比字符串）是否相同
     * 相同 则失焦不去更改保存信息 反之保存
     * @param {string} content 失焦传进来的html内容
     */
    contrastDifferentEditorContent(content, evt) {
      // 获取编辑器真实dom的html内容
      const mybody =
      evt.target.frameElement.contentWindow.document.body;
      this.cacheContent = mybody.innerHTML; 
      console.log(this.cacheContent,'------', this.editorHtmlBeforeClicked, 'editorHtmlBeforeClicked');
      return this.cacheContent;
    },
    handlerEditorBlur(editorInstance,toolbar) {
      let timer = undefined;
      editorInstance.addListener("blur", (editor, evt) => {
        clearTimeout(timer);
        // const content = editorInstance.getContent();
        this.cacheContent = editorInstance.getContent();
        // this.blankEditorBlur(evt);
        // timer = setTimeout(() => {
        let editorHeight = 0;
        // 获取dom实时hmtl
        this.cacheContent = this.contrastDifferentEditorContent(editorInstance.getContent(), evt);
        console.log("编辑器失焦触发",this.msg,this.toolbarClicked,this.imageClicked );
        if (this.toolbarClicked ||this.imageClicked) {
          this.imageClicked = false;
          return;
        } else {
          toolbar && (toolbar.style.display = "none");
        }
        this.realHeightAfterEdit = this.getRealHeightAfterEdit(evt) + PADDING_TOP;// 因为编辑器内部有个向上的内边距高度 需要加上
        editorHeight =
          this.realHeightAfterEdit < this.msg.initDragHeight
            ? this.msg.initDragHeight
            : this.realHeightAfterEdit + MARGIN_BOTTOM;
        let mycontent = this.cacheContent;
       if(mycontent.split(KONGGE_ELEMENT).length > 1) mycontent = this.appendKONGGEToSPAN((mycontent&& mycontent.split(KONGGE_ELEMENT)),KONGGE_ELEMENT);
        mycontent &&
          this.$emit("onBlur", {
            editorHeight: editorHeight,
            content: mycontent,
            isEnterKeyUp: this.isEnterKeyUp,
            overstepDistance: editorHeight - (this.msg.initDragHeight),
          });
        this.toolbarClicked = false;
        this.mouseLeaveSignal = false;
        clearTimeout(timer);
        // }, 80);
      });
    },
    handlerEditorFocus(editorInstance){
      editorInstance.addListener("focus", (editor, evt) => {
        // 获取编辑器真实dom的html内容
        const mybody =
        evt.target.frameElement.contentWindow.document.body;
        this.editorHtmlBeforeClicked = mybody.innerHTML
      })
    },
    /**
     * 监听编辑器里面的键盘事件（这里为了监听删除图片的回车键 将图片imageclicked字段置为false）
     */
    handlerEditorKeydowm(editorInstance){
      editorInstance.addListener("keydown", (editor, evt) => {
           this.imageClicked && (this.imageClicked = false);
      })
    },
    appendKONGGEToSPAN(target, str) {
      if(target) {
        return target.map((item,index) => {
          const istrue = item.indexOf('&#8203') != -1;
          // const hasWHITE_SPACE = item.indexOf('<span style="white-space: normal;">&nbsp; &nbsp') != -1;
          // const hasWHITE_SPACE_NONBSP = item.indexOf('<span style="white-space: normal;">') != -1;
          // const prevHAS_TEXT_UNDELINE = target[index-1] && target[index-1].indexOf('<span style="text-decoration: underline;">') != -1;
          // const prevHAS_SPACE = target[index-1] && target[index-1].indexOf('<span style="white-space: normal;">') != -1;
          // const prevHAS_SPACE_BOTH = target[index-1] && target[index-1].indexOf('<<span style="white-space: normal; text-decoration-line: underline;">') != -1;
          // if(hasWHITE_SPACE) {
          //  item = item.replace(/<span style="white-space: normal;">&nbsp; &nbsp+/g, WHITE_SPACE_NBSP);
          // } else if( (hasWHITE_SPACE_NONBSP && prevHAS_TEXT_UNDELINE) || prevHAS_SPACE || prevHAS_SPACE_BOTH) {
          //  item = item.replace(/<span style="white-space: normal;">+/g, WHITE_SPACE_NONBSP);
          // }
          // return index == target.length-1 ? item : `${item}&#8203;` ;
          return item.indexOf('&#8203') != -1 ? item : item.replace(/&nbsp+/g, '&nbsp;&#8203');
        }).join(str)
      } else {
        return target || '';
      }
    },
    blankEditorBlur(evt) {
      if(this.msg.type == 1) {
       try {
        const mybody =
          evt.target.frameElement.contentWindow.document.body;
          this.cacheContent = mybody.innerHTML;
       } catch (e) {
         console.error('获取填空题dom出错',e.message);
       }
      }
    },
    ready(editorInstance) {
      // vue模板更新视图的时候会导致编辑器初始化，初始化导致焦点回到原点 这里焦点强制到末尾
      // 编辑器的问题大部分都集中在这里的监听事件
      // console.log(editorInstance);
      this.editorInstance = editorInstance;
      const myeditor = document.getElementById(editorInstance.key);
      const toolbar = myeditor.querySelector(".edui-editor-toolbarbox");
      this.showToolbarWhenFocus(editorInstance,toolbar);
      this.handlerToolbarMouseEnter(toolbar)
      toolbar.onclick = () => {
        this.toolbarClicked = true;
      };
      this.handlerEditorMouseDown(editorInstance);
      this.handlerEditorMouseUp(editorInstance);
      // toolbar.onmouseleave = () => {
      //   this.toolbarClicked = false;
      // };
      // editorInstance.addListener("onchange", (editor) => {
      //   console.log(editor, "-------------");
      // });
      this.handlerEditorBlur(editorInstance,toolbar);
      this.handlerEditorFocus(editorInstance);
      this.handlerEditorKeydowm(editorInstance)
      if (this.msg.type == 6) {
        this.editorInstance &&
          this.editorInstance.setHeight(this.msg.initDragHeight - 38);
      } else {
        this.editorInstance &&
          this.editorInstance.setHeight(this.msg.initDragHeight);
      }
      this.setServerParam(editorInstance);
    },
    /**
     * 设置图片上传的入参
     * @param {object} ue 编辑器实例
     * @returns {void}
     */
    setServerParam(ue) {
      const { guid } = this.$route.query;
      guid && ue.execCommand('serverparam', function(editor) {
        return {
         'acGuid': guid  //设置富文本编辑器请求时，携带的额外参数
        };
      });
    },
    /**
     * 获取编辑器编辑之后的高度
     */
    getRealHeightAfterEdit(evt) {
      let realHeightAfterEdit = 0;
      let realHTML = '';
      try {
        const elements =
          evt.target.frameElement.contentWindow.document.body.childNodes;
        Array.from(elements).forEach((el) => {
          if (el.tagName == TAG_NAME_TABLE) {
            realHeightAfterEdit += el.offsetHeight + MARGIN_BOTTOM || 0;
          } else {
            realHeightAfterEdit +=
              el.offsetHeight || (el.tagName ? 0 : TAG_P_HEIGHT); // 如果在表格后面直接输入文字，编辑器会自动换行 然后直接失焦操作的话el.tagName是undefined的，其实是存在生成的p 所以高度得加上
          }
          this.findStyleTextUnderline(el, false);
          realHTML += el.outerHTML || '';
        });
        // !this.cacheContent &&( this.cacheContent = realHTML );
        this.cacheContent = realHTML ;
        return realHeightAfterEdit;
      } catch (e) {
        console.error("获取编辑器下面所有元素报错", e.message);
      }
    },
    /**
     * 递归查找子元素的style 是否有unline属性
     */
    findStyleTextUnderline(el, hasTextUnderline) {
      if(el.children) {
        Array.from(el.children).forEach((elChildrenItem) => {
          const styleStr = elChildrenItem.getAttribute('style');
          const isNotSpanTag = elChildrenItem.tagName != 'SPAN'; // 直接在编辑器输入文字的话 会显示无标签或者a标签内容 是不需要set下划线样式的
          if(styleStr) {
            if(styleStr.indexOf('text-decoration: underline') != -1) {
              hasTextUnderline = true;
            } else {
              hasTextUnderline && !isNotSpanTag && styleStr.indexOf('white-space') != -1 && elChildrenItem.setAttribute('style', styleStr + ';text-decoration: underline')
            }
          }
         el.children.length && this.findStyleTextUnderline(elChildrenItem, hasTextUnderline)
        });
      }
    },
    setToolBarClicked(toolbarClicked) {
      const wrapList = document.querySelectorAll(".vue-ueditor-wrap");

      // this.$refs.ueditorWrap.addListener("mouseleave", (e) => {

      // });
      this.$refs.ueditorWrap.onmouseleave = (e) => {
        this.toolbarClicked = false;
        this.mouseLeaveSignal = true;
      };
    },
    /**
     * 用来更新下划线保存的时候没有&#8203;导致下划线下载pdf不显示问题
     */
    insertSpaceIntoContent(content) {
      // try {
      //   const FIX_SYMBOL = "&#8203;"; // 填充符
      //   const SPLIT_SYMBOL = '<span style="text-decoration: underline;">';
      //   if (content && content.indexOf(SPLIT_SYMBOL) != -1) {
      //     let strArr = content.split(SPLIT_SYMBOL);
      //     strArr = strArr.map((str, index) => {
      //       if (index == 0) {
      //         return str;
      //       } else {
      //         return SPLIT_SYMBOL + FIX_SYMBOL + str;
      //       }
      //     });
      //     return strArr.join("");
      //   } else {
      //     return content;
      //   }
      // } catch (e) {
      //   console.error("处理下划线不显示问题报错", e.message);
      // }
    },
    handlerSaveClick() {
      document.querySelector(".submit-text").onclick = () => {
        let editorHeight =
          this.realHeightAfterEdit < this.msg.initDragHeight
            ? this.msg.initDragHeight
            : this.realHeightAfterEdit + MARGIN_BOTTOM;
        this.$emit("onBlur", {
          editorHeight: editorHeight,
          content: this.cacheContent,
          isEnterKeyUp: this.isEnterKeyUp,
          overstepDistance: editorHeight - this.msg.initDragHeight,
        });
        // const timer = setTimeout(() => {
        //   sessionStorage.clear();
        //   clearTimeout(timer);
        // }, 2000);
        this.toolbarClicked = false;
      };
    },
  },
  watch: {
    "msg.initDragHeight": {
      //handler:'test',
      handler(height) {
        if (this.msg.type == 6) {
          this.editorInstance && this.editorInstance.setHeight(height - 38);
        } else {
          this.editorInstance && this.editorInstance.setHeight(height);
        }
      },
    },
    msg: {
      handler(msg) {
        this.editorInstance && this.editorInstance.setContent(msg.innerHTML);
      },
      deep: true,
    },
  },
  // destroyed() {
  //   this.editorInstance && this.editorInstance.destroy();
  // },
  mounted() {
    this.setToolBarClicked(false);
  },
};
</script>

<style>
.edui-default .edui-editor {
  border: none !important;
}
</style>
